import type { ReactNode } from 'react';

export function Carregando({ linhas = 4, rotulo = 'Carregando…' }: { linhas?: number; rotulo?: string }) {
  return (
    <div role="status" aria-live="polite">
      <span className="sr-only" style={{ position: 'absolute', left: '-9999px' }}>
        {rotulo}
      </span>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {Array.from({ length: linhas }, (_, i) => (
          <div key={i} className="skel" style={{ height: i === 0 ? 26 : 14, width: `${100 - i * 7}%` }} />
        ))}
      </div>
    </div>
  );
}

export function Vazio({ titulo, children }: { titulo: string; children?: ReactNode }) {
  return (
    <div className="empty">
      <h2>{titulo}</h2>
      {children ? <p>{children}</p> : null}
    </div>
  );
}

export function Erro({ erro, aoTentarDeNovo }: { erro: { message: string } | null; aoTentarDeNovo?: () => void }) {
  return (
    <div className="erro-box" role="alert">
      <strong>Não foi possível carregar.</strong> {erro?.message ?? 'Erro desconhecido.'}
      {aoTentarDeNovo ? (
        <>
          {' '}
          <button type="button" className="btn sm" style={{ marginLeft: 8 }} onClick={aoTentarDeNovo}>
            Tentar de novo
          </button>
        </>
      ) : null}
    </div>
  );
}
